import Icon from '@/components/ui/AppIcon';

interface Regulation {
  title: string;
  description: string;
  icon: string;
  type: 'requirement' | 'restriction' | 'guideline';
}

interface RegulationCardProps {
  regulation: Regulation;
}

const RegulationCard = ({ regulation }: RegulationCardProps) => {
  const typeStyles = {
    requirement: {
      card: { backgroundColor: '#0F2234', border: '1px solid rgba(111,211,224,0.2)', borderLeftWidth: '3px', borderLeftColor: '#6FD3E0' },
      icon: { backgroundColor: '#6FD3E0', color: '#0B1622' },
    },
    restriction: {
      card: { backgroundColor: '#0F2234', border: '1px solid rgba(239,68,68,0.2)', borderLeftWidth: '3px', borderLeftColor: '#f87171' },
      icon: { backgroundColor: '#f87171', color: '#0B1622' },
    },
    guideline: {
      card: { backgroundColor: '#0F2234', border: '1px solid rgba(255,138,61,0.2)', borderLeftWidth: '3px', borderLeftColor: '#FF8A3D' },
      icon: { backgroundColor: '#FF8A3D', color: '#0B1622' },
    },
  };

  const styles = typeStyles[regulation.type];

  return (
    <div style={styles.card} className="rounded-xl p-6 transition-all duration-300 hover:shadow-xl shadow-md">
      <div className="flex items-start space-x-4">
        <div style={styles.icon} className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center">
          <Icon name={regulation.icon as any} size={24} />
        </div>
        <div className="flex-1">
          <h3 style={{ color: '#EAF4F8' }} className="text-lg font-headline font-semibold mb-2">
            {regulation.title}
          </h3>
          <p style={{ color: '#C8DDE6' }} className="text-sm leading-relaxed">
            {regulation.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegulationCard;